import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from "react";
import useUniqueId from "../../../Hooks/useUniqueId";
const MessageTemplatePreview = ({ watch, personalizationMenus }) => {
    const makeId = useUniqueId()[1];
    const subject = watch("subject");
    const body = watch("body");
    // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'UseServiceState<{ menus: TemplateMenu; }> | undefined'.
    const { data = {} } = personalizationMenus;
    // USE MEMO TO OPTIMIZE
    const getPreviewTextByVariable = useCallback((variable) => {
        const menus = 
        // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments. | TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'item' implicitly has an 'any' type.
        data.menus.reduce((result, item) => {
            return result.concat(item.menus);
        }, []) || [];
        const filteredItem = menus.filter(
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        (item) => item.value === variable);
        if (filteredItem.length !== 0) {
            return filteredItem[0].previewText;
        }
        return null;
    }, [data]);
    const replacePersonalizationVariables = (value = "") => {
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        if (personalizationMenus.wasSuccessful && personalizationMenus.data) {
            const arrMatch = value.match(/(\{.*?\})/g) || [];
            arrMatch.forEach((personalizedVariable) => {
                const variable = personalizedVariable.slice(1, personalizedVariable.length - 1);
                const preview = getPreviewTextByVariable(variable);
                if (preview) {
                    value = value.replace(personalizedVariable, preview);
                }
            });
            return value;
        }
        return value;
    };
    return (_jsxs(_Fragment, { children: [_jsx("h2", { className: "mb-3 h3", children: "Preview" }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("subject"), className: "font-weight-bold mb-0", children: "Subject" }), _jsx("div", { children: replacePersonalizationVariables(subject) || "" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("message"), className: "font-weight-bold mb-0", children: "Message" }), _jsx("div", { dangerouslySetInnerHTML: {
                            __html: replacePersonalizationVariables(body) || "",
                        } })] })] }));
};
export default MessageTemplatePreview;
